module.exports = __webpack_public_path__ + "media/welcome-audio.ecc696fd.mp3";